import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { RitwikiService } from '../../services/raintree/Transmission/ritwiki.service';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';


@Component({
  selector: 'app-ritwik-popup',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './ritwik-popup.component.html',
  styleUrl: './ritwik-popup.component.scss'
})
export class RitwikPopupComponent implements OnInit {
  data: any = '';

  demoArr = {
    bankData: {
      bankName: 'State Bank of India',
      ifscCode: 'SBIU0012422',
      branchName: 'Falakata Branch',
      accNo: '2123848483731',
      accHolderName: 'Pratik Dutta',
      url: 'https://picsum.photos/300/200'
    }

  }

  constructor(
    private fb: FormBuilder,
    private apiService: RitwikiService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData: any,
    @Optional() private sheetRef?: MatBottomSheetRef<RitwikPopupComponent>,
    @Optional() private dialogRef?: MatDialogRef<RitwikPopupComponent>,
  ) {
    this.data = dialogData || sheetData
  }

  isMobile: boolean = false;
  file: any
  imagePreview!: string;
  // code = new FormControl('')


  bankDetails = this.fb.group({
    accountHolder: ['', Validators.required],
    accountNumber: ['', [Validators.required, Validators.maxLength(11)]],
    ifscCode: ['', [Validators.required, Validators.maxLength(11)]],
    bankName: ['', Validators.required],
    branchName: ['', Validators.required],
  })

  ngOnInit(): void {
    console.log(this.data.type);

    this.isMobile = window.matchMedia('(max-width: 500px)').matches;

    this.bankDetails.valueChanges?.subscribe((item: any) => {
      Object.keys(item).forEach(key => {
        const value = item[key]
        if (typeof value === 'string') {
          this.bankDetails.get(key)?.setValue(value.toUpperCase(), {
            emitEvent: false
          });
        }
      })
    })

    if (this.data.isBankDetails) {
      // this.imagePreview = this.demoArr.bankData.url
      this.bankDetails.setValue({
        accountHolder: this.data.details.accHolderName,
        accountNumber: this.data.details.masked_account,
        ifscCode: this.data.details.ifscCode,
        bankName: this.data.details.bankName,
        branchName: this.data.details.branchName || '',
      })
      const values = {
        ifsc: this.data.details.ifscCode
        // }
      }
      this.apiService.ifscDetails(values).subscribe({
        next: (res) => {
          this.bankDetails.get('bankName')?.setValue(res.data[0].bankName)
          this.bankDetails.get('branchName')?.setValue(res.data[0].branchName)
        }
      })

    }


  }

  close() {
    this.dialogRef?.close(false)
    this.sheetRef?.dismiss(false)

  }

  getBankDetails(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    console.log(value);
    if (value.length === 11) {
      let values: any;
      // if(this.data.isBankDetails){
      //    values = {
      //   ifsc: this.data.details.ifscCode
      // }
      // }else{
      values = {
        ifsc: value
        // }
      }
      this.apiService.ifscDetails(values).subscribe({
        next: (res) => {
          this.bankDetails.get('bankName')?.setValue(res.data[0].bankName)
          this.bankDetails.get('branchName')?.setValue(res.data[0].branchName)
        }
      })
    }

    // })

  }

  restrictOtpInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /^[0-9]*$/;
    if (pattern.test(input) || input === 'Backspace') {
      return;
    } else {
      event.preventDefault();
    }
  }

  uploadImg() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    // 📱 Mobile → Camera
    if (this.isMobile) {
      input.setAttribute('capture', 'environment');
    }

    input.onchange = (event: any) => {
      const fileN = (event.target as HTMLInputElement).files?.[0];
      // this.file = event.target.files[0];
      this.file = fileN;
      if (this.file) {

        const reader = new FileReader();
        reader.onload = () => {
          // this.imgArr = []
          this.imagePreview=(reader.result as string);
        };
        reader.readAsDataURL(this.file);
        
        

        // this.imagePreview = URL.createObjectURL(this.file);
        // console.log(this.imagePreview);
        
        // console.log(this.file, 'img');


        // this.submit(payload);




      }
    };

    input.click();
  }

  objectToFormData(
    obj: any,
    formData: FormData = new FormData(),
    parentKey: string | null = null
  ): FormData {

    if (obj === null || obj === undefined) {
      return formData;
    }

    Object.keys(obj).forEach(key => {
      const value = obj[key];
      const formKey = parentKey ? '${parentKey}[${key}]' : key;

      if (value instanceof File || value instanceof Blob) {
        formData.append(formKey, value);
      }
      else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const arrayKey = '${formKey}[${index}]';
          if (typeof item === 'object' && item !== null) {
            this.objectToFormData(item, formData, arrayKey);
          } else {
            formData.append(arrayKey, item);
          }
        });
      }
      else if (typeof value === 'object' && value !== null) {
        this.objectToFormData(value, formData, formKey);
      }
      else {
        formData.append(formKey, value);
      }
    });

    this.apiService.addBankdetails(formData).subscribe({
      next: (res) => {
        console.log(res.data);
        this.dialogRef?.close(true)
        this.sheetRef?.dismiss(true)

      }

    })

    return formData

  }

  submit(obj?: any) {
    let payload = {
      bankDoc: this.file,
      accountHolderName: this.bankDetails.get('accountHolder')?.value,
      bankAccountNumber: this.bankDetails.get('accountNumber')?.value,
      bankIfscCode: this.bankDetails.get('ifscCode')?.value,
      bankName: this.bankDetails.get('bankName')?.value,
      bankBranchName: this.bankDetails.get('branchName')?.value,
    }
    this.objectToFormData(payload)
  }
}
